'use client';

import { useEffect, useState } from 'react';

import { useRouter } from 'next/navigation';

import {
  WEBSITE_BETA_END,
  isWebsiteBetaOpen,
} from '~/config/website-signup.config';

/** Refresh even a tab left open across the scheduled cutover. */
export function useWebsiteBeta() {
  const [open, setOpen] = useState(isWebsiteBetaOpen);
  const router = useRouter();
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const sync = () => {
      clearTimeout(timer);
      const next = isWebsiteBetaOpen();
      setOpen(next);
      if (open && !next) router.refresh();
      if (next)
        timer = setTimeout(
          sync,
          Math.min(
            86_400_000,
            Math.max(1, Date.parse(WEBSITE_BETA_END) - Date.now()),
          ),
        );
    };
    sync();
    window.addEventListener('focus', sync);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('focus', sync);
    };
  }, [open, router]);
  return open;
}
